import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import { SHARED_NAMESPACE } from '@/store/shared'

export const PESharedPhotoActions = {
  peUploadPartyPhoto: async ({ commit, getters, dispatch }, { filename, photo, photoOriginal }) => {
    const party = getters.peParty

    const formData = new FormData()
    const rawFilename = filename.split('.').slice(0, -1)
    const filenameExtension = filename.split('.').slice(-1)
    formData.append('file', photo, filename)
    formData.append('file_original', photoOriginal, `${rawFilename}_original.${filenameExtension}`)

    return axiosRequest.patch(`/parties/${party.id}/upload`, formData).
      then(({ data }) => {
        const updatedParty = data.party
        commit('pePatchParty', {
          photo: updatedParty.photo,
          photo_original: updatedParty.photo_original,
        })

        dispatch('peProcessPhoto')
      }).
      catch(handleError)
  },
  peProcessPhoto: async ({ commit, getters, dispatch }) => {
    const party = getters.peParty

    commit('peSetPhotoLoading', true)

    try {
      if (!party.photo?.id) {
        commit('peSetPhotoBlob', null)
        commit('peSetPhotoOriginalBlob', null)
        return
      }

      const blob = await dispatch(`${SHARED_NAMESPACE}/getThumbnailForAttachment`, party.photo.id, { root: true })
      commit('peSetPhotoBlob', blob)

      const originalBlob = await dispatch(
        `${SHARED_NAMESPACE}/downloadAttachment`,
        party.photo_original?.id ? party.photo_original.id : party.photo.id,
        { root: true }
      )

      commit('peSetPhotoOriginalBlob', originalBlob)
    } finally {
      commit('peSetPhotoLoading', false)
    }
  },
  peRefreshPhoto: async ({ commit, getters, dispatch }) => {
    return axiosRequest.
      get(`/parties/${getters.peParty.id}/photo`).
      then(({ data }) => {
        const updatedParty = data.party
        commit('pePatchParty', {
          photo: updatedParty.photo,
          photo_original: updatedParty.photo_original,
        })

        dispatch('peProcessPhoto')
      }).
      catch(handleError)
  },
}

export const PESharedPhotoGetters = {
  peGetPhotoBlob: state => state.partyEdit.photoBlob,
  peGetPhotoDataUrl: state => {
    if (state.partyEdit.photoBlob) return URL.createObjectURL(state.partyEdit.photoBlob)
    return null
  },
  peGetPhotoOriginalBlob: state => state.partyEdit.photoOriginalBlob,
  peGetPhotoOriginalDataUrl: state => {
    if (state.partyEdit.photoOriginalBlob) return URL.createObjectURL(state.partyEdit.photoOriginalBlob)
    return null
  },
  pePhotoLoading: state => state.partyEdit.photoLoading,
}

export const PESharedPhotoMutations = {
  peSetPhotoBlob: (state, data) => { Vue.set(state.partyEdit, 'photoBlob', data) },
  peSetPhotoLoading: (state, value) => { Vue.set(state.partyEdit, 'photoLoading', value) },
  peSetPhotoOriginalBlob: (state, data) => { Vue.set(state.partyEdit, 'photoOriginalBlob', data) },
}
